import { render, staticRenderFns } from "./OccupationalSafetysSection.vue?vue&type=template&id=45904a7e"
import script from "./OccupationalSafetysSection.vue?vue&type=script&lang=js"
export * from "./OccupationalSafetysSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports